export default function Datenschutz() {
  return (
    <div data-testid="page-datenschutz" className="px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-24">
      <div className="text-xs uppercase tracking-[0.3em] text-primary mb-6">Rechtliches</div>
      <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tighter mb-12">
        Datenschutzerklärung
      </h1>
      <div className="max-w-2xl space-y-10 text-foreground/90 leading-relaxed">
        <p className="text-sm text-muted-foreground">
          Wir freuen uns über Ihr Interesse an unserem Unternehmen. Der Schutz
          Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Im
          Folgenden informieren wir Sie gemäß der Datenschutz-Grundverordnung
          (DSGVO) darüber, welche Daten wir verarbeiten, zu welchem Zweck und
          auf welcher Rechtsgrundlage.
        </p>

        <section>
          <h2 className="font-serif text-2xl mb-3">1. Verantwortlicher</h2>
          <p className="text-sm text-muted-foreground">
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            Keppel Immobilien<br />
            Inhaber: Jeremy Keppel<br />
            Kulmbacher Straße 74<br />
            95213 Münchberg<br />
            Telefon: 0221 – 64 00 90 81<br />
            E-Mail:{" "}
            <a
              href="mailto:post@keppel-immobilien.de"
              className="hover:text-primary"
            >
              post@keppel-immobilien.de
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">
            2. Zugriffsdaten und Hosting
          </h2>
          <p className="text-sm text-muted-foreground">
            Beim Aufruf unserer Website werden durch den von uns beauftragten
            Hosting-Dienstleister automatisch Informationen in sogenannten
            Server-Logfiles erfasst, die Ihr Browser übermittelt. Dies sind
            insbesondere: Datum und Uhrzeit des Zugriffs, die aufgerufene Seite
            bzw. Datei, der verwendete Browsertyp nebst Version, das
            Betriebssystem, die Referrer-URL sowie die (gekürzte bzw.
            anonymisierte) IP-Adresse. Diese Daten dienen ausschließlich der
            technischen Bereitstellung, der Stabilität und der Sicherheit der
            Website und werden nicht mit anderen Datenquellen zusammengeführt.
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren
            und stabilen Betrieb der Website (Art. 6 Abs. 1 lit. f DSGVO). Unser
            Hoster verarbeitet diese Daten in unserem Auftrag auf Grundlage eines
            Vertrags zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">
            3. Kontaktaufnahme und Formulare
          </h2>
          <p className="text-sm text-muted-foreground">
            Wenn Sie uns per E-Mail, Telefon oder über eines unserer Formulare
            (Verkaufs-/Kontaktformular sowie Bewerbungsformular für
            Mietinteressenten) kontaktieren, verarbeiten wir die von Ihnen
            mitgeteilten Angaben, um Ihre Anfrage zu bearbeiten und für den Fall
            von Anschlussfragen.
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            <strong className="text-foreground/90">
              Verkaufs- / Kontaktanfrage:
            </strong>{" "}
            Hierbei verarbeiten wir insbesondere Ihren Namen, Ihre
            Kontaktdaten (E-Mail, Telefon) sowie die Angaben zu der von Ihnen
            angebotenen Immobilie bzw. Ihrem Anliegen.
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            <strong className="text-foreground/90">
              Bewerbung als Mietinteressent:
            </strong>{" "}
            Im Rahmen einer Wohnungsbewerbung verarbeiten wir die von Ihnen
            freiwillig angegebenen Daten, u. a. Name, E-Mail, Telefon,
            Geburtsjahr, Haushaltsgröße, Angaben zu Haustieren und
            Raucherstatus, Beruf und Arbeitgeber, Einkommensrahmen,
            SCHUFA-Bereitschaft, gewünschte Stadt/Objekt, Zimmeranzahl,
            gewünschtes Einzugsdatum sowie Ihre Nachricht. Diese Angaben dienen
            ausschließlich der Prüfung und Anbahnung eines möglichen
            Mietverhältnisses. Die Angabe dieser Daten ist freiwillig; ohne sie
            können wir Ihre Bewerbung jedoch ggf. nicht berücksichtigen.
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            Rechtsgrundlage ist die Durchführung vorvertraglicher Maßnahmen bzw.
            die Anbahnung oder Erfüllung eines Vertrags (Art. 6 Abs. 1 lit. b
            DSGVO) sowie – bei allgemeinen Anfragen – unser berechtigtes
            Interesse an der Beantwortung Ihrer Anfrage (Art. 6 Abs. 1 lit. f
            DSGVO). Soweit Sie uns eine ausdrückliche Einwilligung erteilt haben,
            erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO; diese können Sie jederzeit mit Wirkung für die Zukunft
            widerrufen.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">4. Weitergabe von Daten</h2>
          <p className="text-sm text-muted-foreground">
            Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt
            nicht, es sei denn, dies ist zur Vertragsabwicklung erforderlich, Sie
            haben ausdrücklich eingewilligt oder wir sind gesetzlich dazu
            verpflichtet. Zur technischen Bereitstellung der Website setzen wir
            einen Hosting-Dienstleister als Auftragsverarbeiter ein.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">5. Speicherdauer</h2>
          <p className="text-sm text-muted-foreground">
            Wir speichern personenbezogene Daten nur so lange, wie es für die
            genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungs­
            fristen dies vorsehen. Anfragen, die nicht zu einem Vertrag führen,
            sowie nicht berücksichtigte Bewerbungen löschen wir, sobald sie für
            etwaige Rückfragen nicht mehr benötigt werden, spätestens jedoch
            innerhalb einer angemessenen Frist nach Abschluss des Vorgangs.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">
            6. SSL-/TLS-Verschlüsselung
          </h2>
          <p className="text-sm text-muted-foreground">
            Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-
            Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an dem
            Schloss-Symbol in Ihrer Browserzeile und daran, dass die Adresse mit
            „https://&ldquo; beginnt. So können die Daten, die Sie an uns übermitteln,
            nicht von Dritten mitgelesen werden.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">7. Ihre Rechte</h2>
          <p className="text-sm text-muted-foreground">
            Sie haben im Rahmen der gesetzlichen Bestimmungen jederzeit das
            Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO),
            Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18
            DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie auf Widerspruch
            gegen die Verarbeitung (Art. 21 DSGVO). Eine erteilte Einwilligung
            können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Wenden
            Sie sich hierzu bitte an{" "}
            <a
              href="mailto:post@keppel-immobilien.de"
              className="hover:text-primary"
            >
              post@keppel-immobilien.de
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">
            8. Beschwerderecht bei der Aufsichtsbehörde
          </h2>
          <p className="text-sm text-muted-foreground">
            Unbeschadet anderweitiger Rechtsbehelfe haben Sie das Recht, sich bei
            einer Datenschutz-Aufsichtsbehörde zu beschweren. Die für uns
            zuständige Behörde ist:
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br />
            Promenade 18<br />
            91522 Ansbach
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">9. Aktualität</h2>
          <p className="text-sm text-muted-foreground">
            Stand dieser Datenschutzerklärung: Juni 2026. Durch die
            Weiterentwicklung unserer Website oder aufgrund geänderter
            gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden,
            diese Datenschutzerklärung anzupassen.
          </p>
        </section>
      </div>
    </div>
  );
}
